import styled, { css } from 'styled-components';

import mixin from '../../_foundations/Mixin';

const AVATAR_SIZE = {
  sm: 24,
  md: 32,
  lg: 48,
  xl: 72,
};

export const AvatarImage = styled.div`
  display: inline-block;
  background: transparent no-repeat scroll center center;
  background-size: cover;
`;

export const AvatarContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--neutral-800) no-repeat scroll center center;
  color: var(--neutral-10);
  overflow: hidden;
  ${mixin.elevation({ level: 200 })}
  background-clip: border-box;
  ${(props) =>
    (props.imageUrl || props.color) &&
    css`
      background-color: ${props.color && !props.color.startsWith('#')
        ? `var(--${props.color})`
        : props.color} !important;
    `};
  ${(props) => {
    const size = AVATAR_SIZE[props.size];
    let textSize = 200;
    if (props.size === 'lg') {
      textSize = 400;
    }
    if (props.size === 'sm') {
      textSize = 100;
    }

    return css`
      width: ${size}px;
      height: ${size}px;
      line-height: ${size}px;
      ${mixin.text({ size: textSize })}
      border-radius: 8px;
      border: 0;
      & ${AvatarImage} {
        width: 100%;
        height: 100%;
      }
    `;
  }}
`;
